import { clientApi } from ".";

export default {
  fetchRegions: async () => {
    try {
      const response = await clientApi.getClient().get("/provinces", {params: {channel_id: 1}});
      return response.data;
    } catch (err) {}
  }
};
